import { render, staticRenderFns } from "./editTaxStatus.vue?vue&type=template&id=6a806fa6&scoped=true&"
import script from "./editTaxStatus.vue?vue&type=script&lang=js&"
export * from "./editTaxStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a806fa6",
  null
  
)

export default component.exports